import React from 'react'
//Helpers
import { RealEstateDataPageComponentData } from 'types'
import Hero from '../2'

const HeroProperty_3 = ({
  propertyID,
  multiActionBar,
  align,
  upperCaseLink, // Use fake_address
  global_data,
  hidden,
  is_short,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  return (
    <Hero
      global_data={global_data}
      is_short={is_short}
      propertyID={propertyID}
      multiActionBar={multiActionBar}
      align={align}
      hidden={hidden}
      upperCaseLink={upperCaseLink}
    ></Hero>
  )
}

export default HeroProperty_3
